import { Box } from '@components/Box'
import PaymentReportTable from '../PaymentReportTable'
import { ReportByUserProps } from './interface'
import { ByUserForm } from '../ByUserForm'

function ReportByUser({
  data,
  total,
  amount,
  isLoading,
  initialValues,
  sortBy,
  handleSearch,
  handleSortChange,
  handleWaypointEnter,
  handleReset,
  handleExport,
}: ReportByUserProps) {
  return (
    <>
      <ByUserForm
        initialValues={initialValues}
        handleSearch={handleSearch}
        onResetForm={handleReset}
      />
      {initialValues.submit ? (
        <PaymentReportTable
          sortBy={sortBy}
          data={data}
          total={total}
          amount={amount}
          isLoading={isLoading}
          handleSortChange={handleSortChange}
          handleWaypointEnter={handleWaypointEnter}
        />
      ) : (
        <Box>
          <div className='flex'>
            <div className='flex flex-col items-center justify-center w-full text-secondary-100'>
              <p className='text-[24px] px-[93px] mb-[8px] font-mitr text-secondary-50 flex justify-center font-medium'>
                กดค้นหาเพื่อดูข้อมูล
              </p>
            </div>
          </div>
        </Box>
      )}
    </>
  )
}

export default ReportByUser
